import { OPEN_TELEMETRY_ICON_TEST_IDS } from '@modules/gateways/gateways-test-ids.const'

import openTelemetry16Active from './open-telemetry-16-active.svg'
import openTelemetry20Active from './open-telemetry-20-active.svg'
import openTelemetry20Inactive from './open-telemetry-20-inactive.svg'

import styles from './OpenTelemetryIcon.module.scss'

export type OpenTelemetryIconSize = 16 | 20

type OpenTelemetryIconProps = {
  active?: boolean
  className?: string
  size?: OpenTelemetryIconSize
}

const iconBySizeAndState = {
  16: {
    active: openTelemetry16Active,
    inactive: openTelemetry16Active,
  },
  20: {
    active: openTelemetry20Active,
    inactive: openTelemetry20Inactive,
  },
} as const

export function OpenTelemetryIcon({ active = true, className, size = 16 }: OpenTelemetryIconProps) {
  const icon = iconBySizeAndState[size][active ? 'active' : 'inactive']
  const rootClass = [styles.root, styles[`rootSize${size}`], className].filter(Boolean).join(' ')

  return (
    <span className={rootClass} data-testid={OPEN_TELEMETRY_ICON_TEST_IDS.root} aria-hidden="true">
      <span className={styles.inner}>
        {/* eslint-disable-next-line @next/next/no-img-element -- static SVG import */}
        <img src={icon.src} alt="" width={size} height={size} className={styles.image} />
      </span>
    </span>
  )
}
